export interface EntityDef {
  id: number;
  variant: number;
  name: string;
  isBoss: boolean;
}

/**
 * 495 bestiary entities sourced from Demorck/Isaac-save-manager IEntity.ts.
 * Entity ID + variant uniquely identifies a bestiary slot.
 * Excludes entries with non-integer variants (sub-entities not tracked in save).
 * Duplicate (id, variant) pairs resolved by keeping the last entry.
 */
export const BESTIARY_ENTITIES: EntityDef[] = [
  // --- Regular enemies (id 10–311) ---
  { id: 10, variant: 0, name: "Frowning Gaper", isBoss: false },
  { id: 10, variant: 1, name: "Gaper", isBoss: false },
  { id: 10, variant: 2, name: "Flaming Gaper", isBoss: false },
  { id: 10, variant: 3, name: "Rotten Gaper", isBoss: false },
  { id: 11, variant: 0, name: "Gusher", isBoss: false },
  { id: 11, variant: 1, name: "Pacer", isBoss: false },
  { id: 12, variant: 0, name: "Horf", isBoss: false },
  { id: 13, variant: 0, name: "Fly", isBoss: false },
  { id: 14, variant: 0, name: "Pooter", isBoss: false },
  { id: 14, variant: 1, name: "Super Pooter", isBoss: false },
  { id: 14, variant: 2, name: "Tainted Pooter", isBoss: false },
  { id: 15, variant: 0, name: "Clotty", isBoss: false },
  { id: 15, variant: 1, name: "Clot", isBoss: false },
  { id: 15, variant: 2, name: "I.Blob", isBoss: false },
  { id: 15, variant: 3, name: "Grilled Clotty", isBoss: false },
  { id: 16, variant: 0, name: "Mulligan", isBoss: false },
  { id: 16, variant: 1, name: "Mulligoon", isBoss: false },
  { id: 16, variant: 2, name: "Mulliboom", isBoss: false },
  { id: 18, variant: 0, name: "Attack Fly", isBoss: false },
  { id: 19, variant: 0, name: "Larry Jr.", isBoss: true },
  { id: 19, variant: 1, name: "The Hollow", isBoss: true },
  { id: 19, variant: 2, name: "Tuff Twins", isBoss: true },
  { id: 19, variant: 3, name: "The Shell", isBoss: true },
  { id: 20, variant: 0, name: "Monstro", isBoss: true },
  { id: 21, variant: 0, name: "Maggot", isBoss: false },
  { id: 22, variant: 0, name: "Hive", isBoss: false },
  { id: 22, variant: 1, name: "Drowned Hive", isBoss: false },
  { id: 22, variant: 2, name: "Holy Mulligan", isBoss: false },
  { id: 22, variant: 3, name: "Tainted Mulligan", isBoss: false },
  { id: 23, variant: 0, name: "Charger", isBoss: false },
  { id: 23, variant: 1, name: "Drowned Charger", isBoss: false },
  { id: 23, variant: 2, name: "Dank Charger", isBoss: false },
  { id: 23, variant: 3, name: "Carrion Princess", isBoss: false },
  { id: 24, variant: 0, name: "Globin", isBoss: false },
  { id: 24, variant: 1, name: "Gazing Globin", isBoss: false },
  { id: 24, variant: 2, name: "Dank Globin", isBoss: false },
  { id: 24, variant: 3, name: "Cursed Globin", isBoss: false },
  { id: 25, variant: 0, name: "Boom Fly", isBoss: false },
  { id: 25, variant: 1, name: "Red Boom Fly", isBoss: false },
  { id: 25, variant: 2, name: "Drowned Boom Fly", isBoss: false },
  { id: 25, variant: 3, name: "Dragon Fly", isBoss: false },
  { id: 25, variant: 4, name: "Bone Fly", isBoss: false },
  { id: 25, variant: 5, name: "Sick Boom Fly", isBoss: false },
  { id: 25, variant: 6, name: "Tainted Boom Fly", isBoss: false },
  { id: 26, variant: 0, name: "Maw", isBoss: false },
  { id: 26, variant: 1, name: "Red Maw", isBoss: false },
  { id: 26, variant: 2, name: "Psychic Maw", isBoss: false },
  { id: 27, variant: 0, name: "Host", isBoss: false },
  { id: 27, variant: 1, name: "Red Host", isBoss: false },
  { id: 27, variant: 3, name: "Hard Host", isBoss: false },
  { id: 28, variant: 0, name: "Chub", isBoss: true },
  { id: 28, variant: 1, name: "C.H.A.D.", isBoss: true },
  { id: 28, variant: 2, name: "Carrion Queen", isBoss: true },
  { id: 29, variant: 0, name: "Hopper", isBoss: false },
  { id: 29, variant: 1, name: "Trite", isBoss: false },
  { id: 29, variant: 2, name: "Eggy", isBoss: false },
  { id: 29, variant: 3, name: "Tainted Hopper", isBoss: false },
  { id: 30, variant: 0, name: "Boil", isBoss: false },
  { id: 30, variant: 1, name: "Gut", isBoss: false },
  { id: 30, variant: 2, name: "Sack", isBoss: false },
  { id: 31, variant: 0, name: "Spitty", isBoss: false },
  { id: 31, variant: 1, name: "Tainted Spitty", isBoss: false },
  { id: 32, variant: 0, name: "Brain", isBoss: false },
  { id: 34, variant: 0, name: "Leaper", isBoss: false },
  { id: 34, variant: 1, name: "Sticky Leaper", isBoss: false },
  { id: 35, variant: 0, name: "Mr. Maw", isBoss: false },
  { id: 35, variant: 2, name: "Mr. Red Maw", isBoss: false },
  { id: 36, variant: 0, name: "Gurdy", isBoss: true },
  { id: 38, variant: 0, name: "Baby", isBoss: false },
  { id: 38, variant: 1, name: "Angelic Baby", isBoss: false },
  { id: 38, variant: 2, name: "Ultra Pride Baby", isBoss: true },
  { id: 38, variant: 3, name: "Wrinkly Baby", isBoss: false },
  { id: 39, variant: 0, name: "Vis", isBoss: false },
  { id: 39, variant: 1, name: "Double Vis", isBoss: false },
  { id: 39, variant: 2, name: "Chubber", isBoss: false },
  { id: 39, variant: 3, name: "Scarred Double Vis", isBoss: false },
  { id: 40, variant: 0, name: "Guts", isBoss: false },
  { id: 40, variant: 1, name: "Scarred Guts", isBoss: false },
  { id: 40, variant: 2, name: "Slog", isBoss: false },
  { id: 41, variant: 0, name: "Knight", isBoss: false },
  { id: 41, variant: 1, name: "Selfless Knight", isBoss: false },
  { id: 41, variant: 2, name: "Loose Knight", isBoss: false },
  { id: 41, variant: 3, name: "Brainless Knight", isBoss: false },
  { id: 41, variant: 4, name: "Black Knight", isBoss: false },
  { id: 42, variant: 0, name: "Stone Grimace", isBoss: false },
  { id: 42, variant: 1, name: "Vomit Grimace", isBoss: false },
  { id: 42, variant: 2, name: "Triple Grimace", isBoss: false },
  { id: 43, variant: 0, name: "Monstro II", isBoss: true },
  { id: 43, variant: 1, name: "Gish", isBoss: true },
  { id: 44, variant: 0, name: "Poky", isBoss: false },
  { id: 44, variant: 1, name: "Slide", isBoss: false },
  { id: 45, variant: 0, name: "Mom", isBoss: true },
  { id: 46, variant: 0, name: "Sloth", isBoss: true },
  { id: 46, variant: 1, name: "Super Sloth", isBoss: true },
  { id: 46, variant: 2, name: "Ultra Pride", isBoss: true },
  { id: 47, variant: 0, name: "Lust", isBoss: true },
  { id: 47, variant: 1, name: "Super Lust", isBoss: true },
  { id: 48, variant: 0, name: "Wrath", isBoss: true },
  { id: 48, variant: 1, name: "Super Wrath", isBoss: true },
  { id: 49, variant: 0, name: "Gluttony", isBoss: true },
  { id: 49, variant: 1, name: "Super Gluttony", isBoss: true },
  { id: 50, variant: 0, name: "Greed", isBoss: true },
  { id: 50, variant: 1, name: "Super Greed", isBoss: true },
  { id: 51, variant: 0, name: "Envy", isBoss: true },
  { id: 51, variant: 1, name: "Super Envy", isBoss: true },
  { id: 52, variant: 0, name: "Pride", isBoss: true },
  { id: 52, variant: 1, name: "Super Pride", isBoss: true },
  { id: 53, variant: 0, name: "Dople", isBoss: false },
  { id: 53, variant: 1, name: "Evil Twin", isBoss: false },
  { id: 54, variant: 0, name: "Flaming Hopper", isBoss: false },
  { id: 55, variant: 0, name: "Leech", isBoss: false },
  { id: 55, variant: 1, name: "Kamikaze Leech", isBoss: false },
  { id: 55, variant: 2, name: "Holy Leech", isBoss: false },
  { id: 56, variant: 0, name: "Lump", isBoss: false },
  { id: 57, variant: 0, name: "MemBrain", isBoss: false },
  { id: 57, variant: 1, name: "Mama Guts", isBoss: false },
  { id: 57, variant: 2, name: "Dead Meat", isBoss: false },
  { id: 58, variant: 0, name: "Para-Bite", isBoss: false },
  { id: 58, variant: 1, name: "Scarred Para-Bite", isBoss: false },
  { id: 59, variant: 0, name: "Fred", isBoss: false },
  { id: 60, variant: 0, name: "Eye", isBoss: false },
  { id: 60, variant: 1, name: "Bloodshot Eye", isBoss: false },
  { id: 60, variant: 2, name: "Holy Eye", isBoss: false },
  { id: 61, variant: 0, name: "Sucker", isBoss: false },
  { id: 61, variant: 1, name: "Spit", isBoss: false },
  { id: 61, variant: 2, name: "Soul Sucker", isBoss: false },
  { id: 61, variant: 3, name: "Ink", isBoss: false },
  { id: 61, variant: 4, name: "Mama Fly", isBoss: false },
  { id: 61, variant: 5, name: "Bulb", isBoss: false },
  { id: 61, variant: 6, name: "Bloodfly", isBoss: false },
  { id: 61, variant: 7, name: "Tainted Sucker", isBoss: false },
  { id: 62, variant: 0, name: "Pin", isBoss: true },
  { id: 62, variant: 1, name: "Scolex", isBoss: true },
  { id: 62, variant: 2, name: "The Frail", isBoss: true },
  { id: 62, variant: 3, name: "Wormwood", isBoss: true },
  { id: 63, variant: 0, name: "Famine", isBoss: true },
  { id: 64, variant: 0, name: "Pestilence", isBoss: true },
  { id: 65, variant: 0, name: "War", isBoss: true },
  { id: 65, variant: 1, name: "Conquest", isBoss: true },
  { id: 66, variant: 0, name: "Death", isBoss: true },
  { id: 66, variant: 10, name: "Death Scythe", isBoss: false },
  { id: 67, variant: 0, name: "The Duke of Flies", isBoss: true },
  { id: 67, variant: 1, name: "The Husk", isBoss: true },
  { id: 68, variant: 0, name: "Peep", isBoss: true },
  // id=68 variant=1 has duplicate: Peep Eye (special) and The Bloat — keep The Bloat
  { id: 68, variant: 1, name: "The Bloat", isBoss: true },
  { id: 68, variant: 11, name: "Bloat Eye", isBoss: false },
  { id: 69, variant: 0, name: "Loki", isBoss: true },
  { id: 69, variant: 1, name: "Lokii", isBoss: true },
  { id: 71, variant: 0, name: "Fistula", isBoss: true },
  { id: 71, variant: 1, name: "Teratoma", isBoss: true },
  { id: 74, variant: 0, name: "Blastocyst", isBoss: true },
  { id: 77, variant: 0, name: "Embryo", isBoss: false },
  { id: 78, variant: 0, name: "Mom's Heart", isBoss: true },
  { id: 78, variant: 1, name: "It Lives", isBoss: true },
  { id: 79, variant: 0, name: "Gemini", isBoss: true },
  { id: 79, variant: 1, name: "Steven", isBoss: true },
  { id: 79, variant: 2, name: "Blighted Ovum", isBoss: true },
  { id: 79, variant: 10, name: "Gemini Baby", isBoss: true },
  { id: 79, variant: 11, name: "Steven Baby", isBoss: true },
  { id: 79, variant: 12, name: "Blighted Ovum Baby", isBoss: true },
  { id: 80, variant: 0, name: "Moter", isBoss: false },
  { id: 81, variant: 0, name: "The Fallen", isBoss: true },
  { id: 81, variant: 1, name: "Krampus", isBoss: true },
  { id: 82, variant: 0, name: "Headless Horseman", isBoss: true },
  { id: 83, variant: 0, name: "Headless Horseman's Head", isBoss: true },
  { id: 84, variant: 0, name: "Satan", isBoss: true },
  { id: 85, variant: 0, name: "Spider", isBoss: false },
  { id: 86, variant: 0, name: "Keeper", isBoss: false },
  { id: 87, variant: 0, name: "Gurgle", isBoss: false },
  { id: 87, variant: 1, name: "Crackle", isBoss: false },
  { id: 88, variant: 0, name: "Walking Boil", isBoss: false },
  { id: 88, variant: 1, name: "Walking Gut", isBoss: false },
  { id: 88, variant: 2, name: "Walking Sack", isBoss: false },
  { id: 89, variant: 0, name: "Buttlicker", isBoss: false },
  { id: 90, variant: 0, name: "Hanger", isBoss: false },
  { id: 91, variant: 0, name: "Swarmer", isBoss: false },
  { id: 92, variant: 0, name: "Heart", isBoss: false },
  { id: 92, variant: 1, name: "Half Heart", isBoss: false },
  { id: 93, variant: 0, name: "Mask Heart", isBoss: false },
  { id: 93, variant: 1, name: "Mask Heart II", isBoss: false },
  { id: 94, variant: 0, name: "Big Spider", isBoss: false },
  { id: 96, variant: 0, name: "Eternal Fly", isBoss: false },
  { id: 97, variant: 0, name: "Mask of Infamy", isBoss: true },
  { id: 98, variant: 0, name: "Heart of Infamy", isBoss: true },
  { id: 99, variant: 0, name: "Gurdy Jr.", isBoss: true },
  { id: 100, variant: 0, name: "Widow", isBoss: true },
  { id: 100, variant: 1, name: "The Wretched", isBoss: true },
  { id: 101, variant: 0, name: "Daddy Long Legs", isBoss: true },
  { id: 101, variant: 1, name: "Triachnid", isBoss: true },
  { id: 102, variant: 0, name: "Isaac", isBoss: true },
  { id: 102, variant: 1, name: "???", isBoss: true },
  // --- Afterbirth enemies (id 201–311) ---
  { id: 201, variant: 0, name: "Stone Eye", isBoss: false },
  { id: 202, variant: 0, name: "Constant Stone Shooter", isBoss: false },
  { id: 202, variant: 10, name: "Cross Grimace", isBoss: false },
  { id: 203, variant: 0, name: "Brimstone Head", isBoss: false },
  { id: 204, variant: 0, name: "Mobile Host", isBoss: false },
  { id: 205, variant: 0, name: "Nest", isBoss: false },
  { id: 206, variant: 0, name: "Baby Long Legs", isBoss: false },
  { id: 206, variant: 1, name: "Small Baby Long Legs", isBoss: false },
  { id: 207, variant: 0, name: "Crazy Long Legs", isBoss: false },
  { id: 207, variant: 1, name: "Small Crazy Long Legs", isBoss: false },
  { id: 208, variant: 0, name: "Fatty", isBoss: false },
  { id: 208, variant: 1, name: "Pale Fatty", isBoss: false },
  { id: 208, variant: 2, name: "Flaming Fatty", isBoss: false },
  { id: 209, variant: 0, name: "Fat Sack", isBoss: false },
  { id: 210, variant: 0, name: "Blubber", isBoss: false },
  { id: 211, variant: 0, name: "Half Sack", isBoss: false },
  { id: 212, variant: 0, name: "Death's Head", isBoss: false },
  { id: 212, variant: 1, name: "Dank Death's Head", isBoss: false },
  { id: 212, variant: 2, name: "Cursed Death's Head", isBoss: false },
  { id: 212, variant: 3, name: "Brimstone Death's Head", isBoss: false },
  { id: 212, variant: 4, name: "Redskull", isBoss: false },
  { id: 213, variant: 0, name: "Mom's Hand", isBoss: false },
  { id: 214, variant: 0, name: "Level 2 Fly", isBoss: false },
  { id: 215, variant: 0, name: "Level 2 Spider", isBoss: false },
  { id: 216, variant: 0, name: "Swinger", isBoss: false },
  { id: 217, variant: 0, name: "Dip", isBoss: false },
  { id: 217, variant: 1, name: "Corn", isBoss: false },
  { id: 217, variant: 2, name: "Brownie Corn", isBoss: false },
  { id: 217, variant: 3, name: "Big Corn", isBoss: false },
  { id: 218, variant: 0, name: "Wall Hugger", isBoss: false },
  { id: 219, variant: 0, name: "Wizoob", isBoss: false },
  { id: 220, variant: 0, name: "Squirt", isBoss: false },
  { id: 220, variant: 1, name: "Dank Squirt", isBoss: false },
  { id: 221, variant: 0, name: "Cod Worm", isBoss: false },
  { id: 222, variant: 0, name: "Ring Fly", isBoss: false },
  { id: 223, variant: 0, name: "Dinga", isBoss: false },
  { id: 224, variant: 0, name: "Oob", isBoss: false },
  { id: 225, variant: 0, name: "Black Maw", isBoss: false },
  { id: 226, variant: 0, name: "Skinny", isBoss: false },
  { id: 226, variant: 1, name: "Rotty", isBoss: false },
  { id: 226, variant: 2, name: "Crispy", isBoss: false },
  { id: 227, variant: 0, name: "Bony", isBoss: false },
  { id: 227, variant: 1, name: "Holy Bony", isBoss: false },
  { id: 228, variant: 0, name: "Homunculus", isBoss: false },
  { id: 229, variant: 0, name: "Tumor", isBoss: false },
  { id: 229, variant: 1, name: "Planetoid", isBoss: false },
  { id: 230, variant: 0, name: "Camillo Jr.", isBoss: false },
  { id: 231, variant: 0, name: "Nerve Ending", isBoss: false },
  { id: 231, variant: 1, name: "Nerve Ending 2", isBoss: false },
  { id: 234, variant: 0, name: "One Tooth", isBoss: false },
  { id: 235, variant: 0, name: "Gaping Maw", isBoss: false },
  { id: 236, variant: 0, name: "Broken Gaping Maw", isBoss: false },
  { id: 237, variant: 0, name: "Gurgling", isBoss: false },
  { id: 237, variant: 1, name: "Gurglings", isBoss: true },
  { id: 237, variant: 2, name: "Turdlings", isBoss: true },
  { id: 238, variant: 0, name: "Splasher", isBoss: false },
  { id: 239, variant: 0, name: "Grub", isBoss: false },
  { id: 240, variant: 0, name: "Wall Creep", isBoss: false },
  { id: 240, variant: 1, name: "Soy Creep", isBoss: false },
  { id: 240, variant: 3, name: "Tainted Soy Creep", isBoss: false },
  { id: 241, variant: 0, name: "Rage Creep", isBoss: false },
  { id: 242, variant: 0, name: "Blind Creep", isBoss: false },
  { id: 243, variant: 0, name: "Conjoined Spitty", isBoss: false },
  { id: 244, variant: 0, name: "Round Worm", isBoss: false },
  { id: 244, variant: 1, name: "Tube Worm", isBoss: false },
  { id: 244, variant: 2, name: "Tainted Round Worm", isBoss: false },
  { id: 244, variant: 3, name: "Tainted Tube Worm", isBoss: false },
  { id: 246, variant: 0, name: "Ragling", isBoss: false },
  { id: 246, variant: 1, name: "Rag Man's Ragling", isBoss: false },
  { id: 247, variant: 0, name: "Flesh Mobile Host", isBoss: false },
  { id: 248, variant: 0, name: "Psychic Horf", isBoss: false },
  { id: 249, variant: 0, name: "Full Fly", isBoss: false },
  { id: 250, variant: 0, name: "Ticking Spider", isBoss: false },
  { id: 251, variant: 0, name: "Begotten", isBoss: false },
  { id: 252, variant: 0, name: "Nulls", isBoss: false },
  { id: 253, variant: 0, name: "Psy Tumor", isBoss: false },
  { id: 254, variant: 0, name: "Floating Knight", isBoss: false },
  { id: 255, variant: 0, name: "Night Crawler", isBoss: false },
  { id: 256, variant: 0, name: "Dart Fly", isBoss: false },
  { id: 257, variant: 0, name: "Conjoined Fatty", isBoss: false },
  { id: 257, variant: 1, name: "Blue Conjoined Fatty", isBoss: false },
  { id: 258, variant: 0, name: "Fat Bat", isBoss: false },
  { id: 259, variant: 0, name: "Imp", isBoss: false },
  { id: 260, variant: 0, name: "The Haunt", isBoss: true },
  { id: 260, variant: 10, name: "Lil' Haunt", isBoss: false },
  { id: 261, variant: 0, name: "Dingle", isBoss: true },
  { id: 261, variant: 1, name: "Dangle", isBoss: true },
  { id: 262, variant: 0, name: "Mega Maw", isBoss: true },
  { id: 263, variant: 0, name: "The Gate", isBoss: true },
  { id: 264, variant: 0, name: "Mega Fatty", isBoss: true },
  { id: 265, variant: 0, name: "The Cage", isBoss: true },
  { id: 266, variant: 0, name: "Mama Gurdy", isBoss: true },
  { id: 267, variant: 0, name: "Dark One", isBoss: true },
  { id: 268, variant: 0, name: "The Adversary", isBoss: true },
  { id: 269, variant: 0, name: "Polycephalus", isBoss: true },
  { id: 269, variant: 1, name: "The Pile", isBoss: true },
  { id: 270, variant: 0, name: "Mr. Fred", isBoss: true },
  { id: 271, variant: 0, name: "Uriel", isBoss: true },
  { id: 271, variant: 1, name: "Fallen Uriel", isBoss: true },
  { id: 272, variant: 0, name: "Gabriel", isBoss: true },
  { id: 272, variant: 1, name: "Fallen Gabriel", isBoss: true },
  { id: 273, variant: 0, name: "The Lamb", isBoss: true },
  { id: 274, variant: 0, name: "Mega Satan", isBoss: true },
  { id: 275, variant: 0, name: "Mega Satan 2", isBoss: true },
  { id: 276, variant: 0, name: "Roundy", isBoss: false },
  { id: 277, variant: 0, name: "Black Bony", isBoss: false },
  { id: 278, variant: 0, name: "Black Globin", isBoss: false },
  { id: 279, variant: 0, name: "Black Globin's Head", isBoss: false },
  { id: 280, variant: 0, name: "Black Globin's Body", isBoss: false },
  { id: 281, variant: 0, name: "Swarm", isBoss: false },
  { id: 282, variant: 0, name: "Mega Clotty", isBoss: false },
  { id: 283, variant: 0, name: "Bone Knight", isBoss: false },
  { id: 284, variant: 0, name: "Cyclopia", isBoss: false },
  { id: 285, variant: 0, name: "Red Ghost", isBoss: false },
  { id: 286, variant: 0, name: "Flesh Death's Head", isBoss: false },
  { id: 287, variant: 0, name: "Mom's Dead Hand", isBoss: false },
  { id: 288, variant: 0, name: "Dukie", isBoss: false },
  { id: 289, variant: 0, name: "Ulcer", isBoss: false },
  { id: 290, variant: 0, name: "Meatball", isBoss: false },
  { id: 291, variant: 0, name: "Pitfall", isBoss: false },
  { id: 291, variant: 1, name: "Suction Pitfall", isBoss: false },
  { id: 291, variant: 2, name: "Teleport Pitfall", isBoss: false },
  { id: 293, variant: 0, name: "Ultra Greed Coin (Spinner)", isBoss: false },
  { id: 293, variant: 1, name: "Ultra Greed Coin (Key)", isBoss: false },
  { id: 293, variant: 2, name: "Ultra Greed Coin (Bomb)", isBoss: false },
  { id: 293, variant: 3, name: "Ultra Greed Coin (Heart)", isBoss: false },
  { id: 295, variant: 0, name: "Corn Mine", isBoss: false },
  { id: 296, variant: 0, name: "Hush Fly", isBoss: false },
  { id: 297, variant: 0, name: "Blue Gaper", isBoss: false },
  { id: 298, variant: 0, name: "Blue Boil", isBoss: false },
  { id: 299, variant: 0, name: "Greed Gaper", isBoss: false },
  { id: 300, variant: 0, name: "Mushroom", isBoss: false },
  { id: 301, variant: 0, name: "Poison Mind", isBoss: false },
  { id: 302, variant: 0, name: "Stoney", isBoss: false },
  { id: 302, variant: 10, name: "Cross Stoney", isBoss: false },
  { id: 303, variant: 0, name: "Blister", isBoss: false },
  { id: 304, variant: 0, name: "The Thing", isBoss: false },
  { id: 305, variant: 0, name: "Ministro", isBoss: false },
  { id: 306, variant: 0, name: "Portal", isBoss: false },
  { id: 306, variant: 1, name: "Lil Portal", isBoss: false },
  { id: 307, variant: 0, name: "Tar Boy", isBoss: false },
  { id: 308, variant: 0, name: "Fistuloid", isBoss: false },
  { id: 309, variant: 0, name: "Gush", isBoss: false },
  { id: 310, variant: 0, name: "Leper", isBoss: false },
  { id: 310, variant: 1, name: "Leper Flesh", isBoss: false },
  { id: 311, variant: 0, name: "Mr. Mine", isBoss: false },
  // --- AB+ bosses (id 401–413) ---
  { id: 401, variant: 0, name: "The Stain", isBoss: true },
  { id: 402, variant: 0, name: "Brownie", isBoss: true },
  { id: 403, variant: 0, name: "The Forsaken", isBoss: true },
  { id: 404, variant: 0, name: "Little Horn", isBoss: true },
  { id: 404, variant: 1, name: "Dark Ball", isBoss: false },
  { id: 405, variant: 0, name: "Rag Man", isBoss: true },
  { id: 406, variant: 0, name: "Ultra Greed", isBoss: true },
  { id: 406, variant: 1, name: "Ultra Greedier", isBoss: true },
  { id: 407, variant: 0, name: "Hush", isBoss: true },
  { id: 409, variant: 0, name: "Rag Mega", isBoss: true },
  { id: 409, variant: 1, name: "Purple Ball", isBoss: false },
  { id: 410, variant: 0, name: "Sisters Vis", isBoss: true },
  { id: 411, variant: 0, name: "Big Horn", isBoss: true },
  { id: 412, variant: 0, name: "Delirium", isBoss: true },
  { id: 413, variant: 0, name: "The Matriarch", isBoss: true },
  // --- Repentance enemies (id 802–893) ---
  { id: 802, variant: 0, name: "Blood Puppy", isBoss: false },
  { id: 804, variant: 0, name: "Quake Grimace", isBoss: false },
  { id: 805, variant: 0, name: "Bishop", isBoss: false },
  { id: 806, variant: 0, name: "Bubbles", isBoss: false },
  { id: 807, variant: 0, name: "Wraith", isBoss: false },
  { id: 808, variant: 0, name: "Willo", isBoss: false },
  { id: 809, variant: 0, name: "Bomb Grimace", isBoss: false },
  { id: 810, variant: 0, name: "Small Leech", isBoss: false },
  { id: 811, variant: 0, name: "Deep Gaper", isBoss: false },
  { id: 812, variant: 0, name: "Sub Horf", isBoss: false },
  { id: 812, variant: 1, name: "Tainted Sub Horf", isBoss: false },
  { id: 813, variant: 0, name: "Blurb", isBoss: false },
  { id: 814, variant: 0, name: "Strider", isBoss: false },
  { id: 815, variant: 0, name: "Fissure", isBoss: false },
  { id: 816, variant: 0, name: "Polty", isBoss: false },
  { id: 816, variant: 1, name: "Kineti", isBoss: false },
  { id: 817, variant: 0, name: "Prey", isBoss: false },
  { id: 817, variant: 1, name: "Mullighoul", isBoss: false },
  { id: 818, variant: 0, name: "Rock Spider", isBoss: false },
  { id: 818, variant: 1, name: "Tinted Rock Spider", isBoss: false },
  { id: 818, variant: 2, name: "Coal Spider", isBoss: false },
  { id: 819, variant: 0, name: "Fly Bomb", isBoss: false },
  { id: 819, variant: 1, name: "Eternal Fly Bomb", isBoss: false },
  { id: 820, variant: 0, name: "Danny", isBoss: false },
  { id: 820, variant: 1, name: "Coal Boy", isBoss: false },
  { id: 821, variant: 0, name: "Blaster", isBoss: false },
  { id: 822, variant: 0, name: "Bouncer", isBoss: false },
  { id: 823, variant: 0, name: "Quakey", isBoss: false },
  { id: 824, variant: 0, name: "Gyro", isBoss: false },
  { id: 824, variant: 1, name: "Grilled Gyro", isBoss: false },
  { id: 825, variant: 0, name: "Fire Worm", isBoss: false },
  { id: 826, variant: 0, name: "Hardy", isBoss: false },
  { id: 827, variant: 0, name: "Faceless", isBoss: false },
  { id: 827, variant: 1, name: "Tainted Faceless", isBoss: false },
  { id: 828, variant: 0, name: "Necro", isBoss: false },
  { id: 829, variant: 0, name: "Mole", isBoss: false },
  { id: 829, variant: 1, name: "Tainted Mole", isBoss: false },
  { id: 830, variant: 0, name: "Big Bony", isBoss: false },
  { id: 831, variant: 0, name: "Gutted Fatty", isBoss: false },
  { id: 831, variant: 10, name: "Gutted Fatty Eye", isBoss: false },
  { id: 831, variant: 20, name: "Festering Guts", isBoss: false },
  { id: 832, variant: 0, name: "Exorcist", isBoss: false },
  { id: 832, variant: 1, name: "Fanatic", isBoss: false },
  { id: 833, variant: 0, name: "Candler", isBoss: false },
  { id: 834, variant: 0, name: "Whipper", isBoss: false },
  { id: 834, variant: 1, name: "Snapper", isBoss: false },
  { id: 834, variant: 2, name: "Flagellant", isBoss: false },
  { id: 835, variant: 0, name: "Peeping Fatty", isBoss: false },
  { id: 835, variant: 10, name: "Peeping Fatty Eye", isBoss: false },
  { id: 836, variant: 0, name: "Vis Versa", isBoss: false },
  { id: 837, variant: 0, name: "Henry", isBoss: false },
  { id: 838, variant: 0, name: "Level 2 Willo", isBoss: false },
  { id: 840, variant: 0, name: "Pon", isBoss: false },
  { id: 841, variant: 0, name: "Revenant", isBoss: false },
  { id: 841, variant: 1, name: "Quad Revenant", isBoss: false },
  { id: 844, variant: 0, name: "Bombgagger", isBoss: false },
  { id: 850, variant: 0, name: "Level 2 Gaper", isBoss: false },
  { id: 850, variant: 1, name: "Level 2 Horf", isBoss: false },
  { id: 850, variant: 2, name: "Level 2 Gusher", isBoss: false },
  { id: 851, variant: 0, name: "Twitchy", isBoss: false },
  { id: 852, variant: 0, name: "Spikeball", isBoss: false },
  { id: 853, variant: 0, name: "Small Maggot", isBoss: false },
  { id: 854, variant: 0, name: "Adult Leech", isBoss: false },
  { id: 855, variant: 0, name: "Level 2 Charger", isBoss: false },
  { id: 855, variant: 1, name: "Elleech", isBoss: false },
  { id: 856, variant: 0, name: "Gasbag", isBoss: false },
  { id: 857, variant: 0, name: "Cohort", isBoss: false },
  { id: 859, variant: 0, name: "Floast", isBoss: false },
  { id: 860, variant: 0, name: "Unborn", isBoss: false },
  { id: 861, variant: 0, name: "Pustule", isBoss: false },
  { id: 862, variant: 0, name: "Cyst", isBoss: false },
  { id: 863, variant: 0, name: "Morningstar", isBoss: false },
  { id: 864, variant: 0, name: "Mockulus", isBoss: false },
  { id: 865, variant: 0, name: "Evis", isBoss: false },
  { id: 866, variant: 0, name: "Dark Esau", isBoss: true },
  { id: 867, variant: 0, name: "Mother's Shadow", isBoss: true },
  { id: 867, variant: 1, name: "Mother's Shadow", isBoss: true },
  { id: 868, variant: 0, name: "Army Fly", isBoss: false },
  { id: 869, variant: 0, name: "Migraine", isBoss: false },
  { id: 870, variant: 0, name: "Drip", isBoss: false },
  { id: 871, variant: 0, name: "Splurt", isBoss: false },
  { id: 872, variant: 0, name: "Cloggy", isBoss: false },
  { id: 873, variant: 0, name: "Fly Trap", isBoss: false },
  { id: 874, variant: 0, name: "Gas Dwarf", isBoss: false },
  { id: 875, variant: 0, name: "Poot Mine", isBoss: false },
  { id: 876, variant: 0, name: "Dump", isBoss: false },
  { id: 876, variant: 1, name: "Dump Head", isBoss: false },
  { id: 877, variant: 0, name: "Grudge", isBoss: false },
  { id: 878, variant: 0, name: "Butt Slicker", isBoss: false },
  { id: 879, variant: 0, name: "Bloaty", isBoss: false },
  { id: 880, variant: 0, name: "Flesh Maiden", isBoss: false },
  { id: 881, variant: 0, name: "Needle", isBoss: false },
  { id: 881, variant: 1, name: "Pasty", isBoss: false },
  { id: 882, variant: 0, name: "Dust", isBoss: false },
  { id: 883, variant: 0, name: "Baby Begotten", isBoss: false },
  { id: 884, variant: 0, name: "Swarm Spider", isBoss: false },
  { id: 885, variant: 0, name: "Cultist", isBoss: false },
  { id: 885, variant: 1, name: "Blood Cultist", isBoss: false },
  { id: 886, variant: 0, name: "Vis Fatty", isBoss: false },
  { id: 886, variant: 1, name: "Fetal Demon", isBoss: false },
  { id: 887, variant: 0, name: "Dusty Death's Head", isBoss: false },
  { id: 888, variant: 0, name: "Shady", isBoss: false },
  { id: 889, variant: 0, name: "Clickety Clack", isBoss: false },
  { id: 890, variant: 0, name: "Maze Roamer", isBoss: false },
  { id: 891, variant: 0, name: "Goat", isBoss: false },
  { id: 891, variant: 1, name: "Black Goat", isBoss: false },
  { id: 892, variant: 0, name: "Poofer", isBoss: false },
  { id: 893, variant: 0, name: "Ball and Chain", isBoss: false },
  // --- Repentance bosses (id 900–951) ---
  { id: 900, variant: 0, name: "Reap Creep", isBoss: true },
  { id: 901, variant: 0, name: "Lil Blub", isBoss: true },
  { id: 902, variant: 0, name: "The Rainmaker", isBoss: true },
  { id: 903, variant: 0, name: "The Visage", isBoss: true },
  { id: 903, variant: 20, name: "Visage Plasma", isBoss: false },
  { id: 904, variant: 0, name: "The Siren", isBoss: true },
  { id: 905, variant: 0, name: "The Heretic", isBoss: true },
  { id: 906, variant: 0, name: "Hornfel", isBoss: true },
  { id: 907, variant: 0, name: "Great Gideon", isBoss: true },
  { id: 908, variant: 0, name: "Baby Plum", isBoss: true },
  { id: 909, variant: 0, name: "The Scourge", isBoss: true },
  { id: 910, variant: 0, name: "Chimera", isBoss: true },
  { id: 911, variant: 0, name: "Rotgut", isBoss: true },
  { id: 912, variant: 0, name: "Mother", isBoss: true },
  { id: 912, variant: 20, name: "Dead Isaac", isBoss: false },
  { id: 913, variant: 0, name: "Min-Min", isBoss: true },
  { id: 914, variant: 0, name: "Clog", isBoss: true },
  { id: 915, variant: 0, name: "Singe", isBoss: true },
  { id: 915, variant: 1, name: "Singe's Ball", isBoss: true },
  { id: 916, variant: 0, name: "Bumbino", isBoss: true },
  { id: 917, variant: 0, name: "Colostomia", isBoss: true },
  { id: 918, variant: 0, name: "Turdlet", isBoss: true },
  { id: 920, variant: 0, name: "The Horny Boys", isBoss: true },
  { id: 921, variant: 0, name: "Clutch", isBoss: true },
  { id: 950, variant: 0, name: "Dogma", isBoss: true },
  { id: 951, variant: 0, name: "The Beast", isBoss: true },
  { id: 951, variant: 10, name: "Ultra Famine", isBoss: true },
  { id: 951, variant: 11, name: "Ultra Famine Fly", isBoss: false },
  { id: 951, variant: 20, name: "Ultra Pestilence", isBoss: true },
  { id: 951, variant: 21, name: "Ultra Pestilence Fly", isBoss: false },
  { id: 951, variant: 23, name: "Ultra Pestilence Fly Ball", isBoss: false },
  { id: 951, variant: 30, name: "Ultra War", isBoss: true },
  { id: 951, variant: 40, name: "Ultra Death", isBoss: true },
  { id: 951, variant: 41, name: "Ultra Death Scythe", isBoss: false },
  { id: 951, variant: 42, name: "Ultra Death Head", isBoss: false },
];

export const BESTIARY_TOTAL = BESTIARY_ENTITIES.length;
